import { Loader, ChangePasswordModal } from 'components';
import { useChangePassword } from 'hooks';
import { ChangePasswordPayload } from 'hooks';

/**
 * Interface for change password props
 */
interface Props {
  show: boolean;
  close: () => void;
}

const ChangePassword: React.FC<Props> = ({ show, close }) => {
  // Hooks
  const { mutate: changePassword, isPending } = useChangePassword(close);

  const submit = (data: { oldPassword: string; password: string }) => {
    const payload: ChangePasswordPayload = {
      old_password: data.oldPassword,
      new_password: data.password,
    };
    changePassword(payload);
  };

  return (
    <>
      <Loader loading={isPending} />
      <ChangePasswordModal show={show} close={close} submit={submit} />
    </>
  );
};

export { ChangePassword };